import styled from 'styled-components'

export const Sidebar = styled.nav`
  top: 0;
  left: 0;
  width: 15vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: sticky;
  background-color: #052e67
`;

export const SidebarContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const SidebarLogoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;

export const SidebarItems = styled.div`
  height: 100%;
  width: 100%;
`;

export const SidebarFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  padding: 12px 14px;
  margin: 10px;
  border-radius: 10px;

  background: rgba(255, 255, 255, 0.05);
  color: #cbd5e1;

  transition: all 0.25s ease;

  &:hover {
    background: rgba(255, 77, 79, 0.15);
    color: #ff4d4f;
    transform: translateX(3px);
  }
`;

export const SidebarFooterLabel = styled.span`
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  gap: 6px;
`;

export const Logo = styled.img`
  width: 150px;
`;

export const Username = styled.span`
  margin-left: 5px;
`;

export const SidebarSubMenu = styled.div`
  color: darkgrey;
  padding-left: 15px;
  font-size: small;
  margin-top: 15px;
  margin-bottom: 15px;
`;

export const SidebarMenuContainer = styled.div`
  margin-top: 60px;
`
export const MenuOption = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 14px;
  margin: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  
  opacity: ${props => (props.active ? 1 : 0.9)};
  background: ${props => props.active ? '#0a53b5' : 'rgba(255,255,255,0.04)'};
  color: #cbd5e1;
  border: 1px solid ${props => props.active ? 'rgba(255,255,255,0.1)' : 'transparent'};

  &:hover {
    background: ${props => props.active ? '#0a53b5' : 'rgba(255,255,255,0.08)'};
    transform: translateX(4px);
    transition: all 0.2s ease;
  }

  ${props => props.active &&
    `
    box-shadow: 0 6px 16px rgba(0,0,0,0.25);
    transform: scale(1.02);
    `
  }

  ${props => props.isSubMenu && 
    `
    margin-left: 35px
    `
  }
`;

export const MenuLabel = styled.div`
  margin-left: 8px;
  font-weight: ${props => (props.active ? 'bold' : 'normal')};
  font-size: small;
`




